<template>
    <div>
        <div class="d-flex justify-content-around font-custom">
            <a class="w-50 cursor-pointer" @click="select('calender')">
                <span class="d-flex justify-content-center" :class="{ 'active text-primary border-custom': calenderActive, 'border-bottom': routeActive }">
                    <span class="mb-2" v-t="'productConfigurator.calenderHeading'" />
                </span>
            </a>
            <a class="w-50 cursor-pointer" @click="select('route')">
                <span class="d-flex justify-content-center " :class="{ 'active text-primary border-custom': routeActive, 'border-bottom': calenderActive  }">
                    <span class="mb-2" v-t="'productConfigurator.routeHeading'" />
                </span>
            </a>
        </div>
        <div class="mt-2 mb-3">
            <div v-show="calenderActive">
                <Calendar
                    :max-validity-start="maxValidityStart"
                    :max-validity-end="maxValidityEnd"
                />
            </div>
            <div v-show="routeActive" class="map-height">
                <Container
                    map-id="googleMap"
                    design="configurator"
                    :product-route="productRoute"
                    :initial-map-lat="initialMapLat"
                    :initial-map-lng="initialMapLng"
                    :default-zoom="defaultZoom"
                    :show-calendar-as-result="true"
                    :max-validity-start="maxValidityStart"
                    :max-validity-end="maxValidityEnd"
                ></Container>
            </div>
        </div>
    </div>
</template>

<script>
import Calendar from './Calendar/Calendar.vue';
import Container from '../Map/Container.vue';

export default {
    components: {
        Calendar,
        Container,
    },

    props: {
        systems: {
            type: Array,
            required: true,
        },
        maxValidityStart: {
            type: String,
            required: false,
        },
        maxValidityEnd: {
            type: String,
            required: false,
        },
        productRoute: {
            type: String,
            required: true,
        },
        initialMapLat: {
            type: Number,
            required: false,
            default() {
                return 47.6928623;
            },
        },
        initialMapLng: {
            type: Number,
            required: false,
            default() {
                return 12.2247775;
            },
        },
        defaultZoom: {
            type: Number,
            required: false,
            default() {
                return 13;
            },
        },
    },

    data() {
        return {
            calenderActive: true,
            routeActive: false,
        };
    },

    provide() {
        return {
            systems: this.systems,
        };
    },

    methods: {
        /**
         * Handle the selection of tabs.
         */
        select(type) {
            if (type === 'route') {
                this.calenderActive = false;
                this.routeActive = true;
            } else if (type === 'calender') {
                this.calenderActive = true;
                this.routeActive = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.border-custom {
    border-bottom: 2px solid var(--main-color);
}
.map-height {
    min-height: 570px
}
@media (min-width: 992px) {
    .font-custom {
        font-size: 22px;
        font-weight: 300;
    }
}
</style>
